const EMAIL_PATTERN = /^[^\s@/:]+@[^\s@/:]+\.[^\s@/:]+$/;
const SCHEME_PATTERN = /^[a-z][a-z0-9+.-]*:/i;
const BARE_HOST_PATTERN = /^[a-z0-9-]+(\.[a-z0-9-]+)+(:\d+)?([/?#].*)?$/i;

export function normalizeLinkInBioUrl(
  value: string | null | undefined,
  { allowEmail = false }: { allowEmail?: boolean } = {},
): string | null {
  const trimmed = (value ?? '').trim();
  if (!trimmed || /\s/.test(trimmed)) return null;

  if (allowEmail) {
    if (EMAIL_PATTERN.test(trimmed)) return `mailto:${trimmed}`;
    if (/^mailto:/i.test(trimmed)) {
      return EMAIL_PATTERN.test(trimmed.slice('mailto:'.length).split('?')[0]) ? trimmed : null;
    }
  }

  const candidate = SCHEME_PATTERN.test(trimmed)
    ? trimmed
    : BARE_HOST_PATTERN.test(trimmed)
      ? `https://${trimmed}`
      : null;
  if (!candidate) return null;

  try {
    const url = new URL(candidate);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
    if (!url.hostname) return null;
    return candidate;
  } catch {
    return null;
  }
}
